import { Component, ViewEncapsulation, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../../models/user';
import { AppComponent } from 'src/app/app.component';


@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NavMenuComponent { //implements OnInit
  url = '';
  appComponent: AppComponent;
  serverError = false;

  constructor(private http: HttpClient, public user: User, private root: AppComponent) {
    this.appComponent = root;
  }

  private dropdownOpen = signal(false);
  private addMenuDropdownOpen = signal(false);
  isDropdownOpen(): boolean {
    return this.dropdownOpen();
  }

  isAddMenuDropdownOpen(): boolean {
    return this.addMenuDropdownOpen();
  }

  toggleDropdown(): void {
    this.dropdownOpen.set(!this.dropdownOpen());
    // Close other dropdowns when opening this one
    if (this.dropdownOpen()) {
      this.addMenuDropdownOpen.set(false);
    }
  }

  toggleAddMenuDropdown(): void {
    this.addMenuDropdownOpen.set(!this.addMenuDropdownOpen());
    // Close other dropdowns when opening this one
    if (this.addMenuDropdownOpen()) {
      this.dropdownOpen.set(false);
    }
  }

  // Close dropdowns when clicking outside
  closeDropdowns(): void {
    this.dropdownOpen.set(false);
    this.addMenuDropdownOpen.set(false);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occured', error); // for testing purposes only, need to handle
    return Promise.reject(error.message || error);
  }

  checkAccess(role: string[]): boolean {
    return this.user.checkAccess(role);
  }

  logout(): void {
    this.root.logout(true);
  }

  //Thinking adding last data sent check to nav menu could cause too many issues for the moment

  // public checkAllServersLastDataSent() {
  //   forkJoin({
  //     serverList: this.clientIntegrationService.getAllServersInformation(),
  //     map: this.clientIntegrationService.getAllServersLastDataSent()}).subscribe(({map, serverList}) => {
  //       for(let key in map) {
  //         map[key] = new Date(map[key]);

  //         let serverAlertTimespan = serverList.find(s => s.serverId == key).serverAlertTimespan;

  //         // Check if current time is far enough ahead of lastdatasent
  //         if(map[key].getTime() < Date.now() - (serverAlertTimespan * 60 * 1000)) {
  //           this.serverError = true;
  //           break;
  //         }
  //       }
  //   });

  // }

  //setWidth(navWidth: number) {
  //  this.navWidth = navWidth;
  //}
  //setIsMobile(val: boolean) {
  //  this.isMobile = val;
  //}
  //setMobileOpened(val: boolean) {
  //  //this.isMobileMenuOpened = val;
  //}

}
